import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TabFilters } from '../../tab-filters/TabFilters'
import { MediaContentTypes } from '../types'
import { ContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'
import styles from '../GalleryModal.module.scss'

type ContentTypeFilterSectionProps = {
  items: ContentItem[]
  activeContentTypeFilter: MediaContentTypes
  updateActiveContentTypeFilter: (type: MediaContentTypes) => void
  totals: {
    builderItemsTotal: number
    videoItemsTotal: number
    threeDViewItemsTotal: number
  }
}

export const ContentTypeFilterSection: FC<ContentTypeFilterSectionProps> = ({
  items,
  totals,
  updateActiveContentTypeFilter,
  activeContentTypeFilter,
}) => {
  const { t } = useTranslation()

  const filterTabsOptions = [
    {
      label: t('COMPONENTS.MEDIA_GALLERY.CONTENT_TYPE_TABS.ALL'),
      value: MediaContentTypes.All,
      total: items.length > 1 ? items.length : undefined,
    },
    {
      label: t('COMPONENTS.MEDIA_GALLERY.CONTENT_TYPE_TABS.BUILDER'),
      value: MediaContentTypes.Builder,
      total: totals.builderItemsTotal > 1 ? totals.builderItemsTotal : undefined,
      disabled: totals.builderItemsTotal === 0,
    },
    {
      label: t('COMPONENTS.MEDIA_GALLERY.CONTENT_TYPE_TABS.THREE_D_VIEW'),
      value: MediaContentTypes.ThreeDView,
      total: totals.threeDViewItemsTotal > 1 ? totals.threeDViewItemsTotal : undefined,
      disabled: totals.threeDViewItemsTotal === 0,
    },
    {
      label: t('COMPONENTS.MEDIA_GALLERY.CONTENT_TYPE_TABS.VIDEO'),
      value: MediaContentTypes.Video,
      total: totals.videoItemsTotal > 1 ? totals.videoItemsTotal : undefined,
      disabled: totals.videoItemsTotal === 0,
    },
  ]

  return (
    <div className={styles.contentTypeFilterTabs}>
      <TabFilters<MediaContentTypes>
        spaceBetween={24}
        options={filterTabsOptions}
        onChangeTab={(value) => updateActiveContentTypeFilter(value)}
        activeTab={activeContentTypeFilter || MediaContentTypes.All}
      />
    </div>
  )
}
